var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendAndPay = function SvgSendAndPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v16l3-2 2 2 2-2m3 0h7m0 0-3-3m3 3-3 3M12.867 9a1.334 1.334 0 0 0-1.2-.666h-1.334a1.333 1.333 0 0 0 0 2.667h1.334a1.333 1.333 0 1 1 0 2.666h-1.334a1.333 1.333 0 0 1-1.2-.666M11 7v1.333m0 5.334V15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSendAndPay;